
interface AreaServicesProps {
  area: string;
}

export default function AreaServices({ area }: AreaServicesProps) {
  const services = [
    {
      icon: 'ri-paint-brush-line',
      title: 'Interior Painting',
      description: `Transform your ${area} home with our professional interior painting services. We use premium paints and expert techniques.`,
    },
    {
      icon: 'ri-home-4-line',
      title: 'Exterior Painting',
      description: `Protect and beautify your ${area} property with our durable exterior painting solutions that withstand the elements.`,
    },
    {
      icon: 'ri-image-line',
      title: 'Wallpaper Installation',
      description: `Expert wallpaper hanging services in ${area}. We handle all types of wallpaper with precision and care.`,
    },
    {
      icon: 'ri-palette-line',
      title: 'Colour Consultation',
      description: `Get professional advice on color schemes for your ${area} property. We help you choose the perfect palette.`,
    },
    {
      icon: 'ri-building-2-line',
      title: 'Commercial Painting',
      description: `Professional commercial painting services for ${area} businesses. Minimal disruption, maximum quality.`,
    },
    {
      icon: 'ri-tools-line',
      title: 'Decorative Finishes',
      description: `Add unique character to your ${area} property with our specialist decorative painting and finishing services.`,
    },
  ];

  return (
    <section className="py-20 px-6 bg-gray-50">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-800 mb-4">
            Our Services in {area}
          </h2>
          <p className="text-lg text-sky-600 font-medium">
            Comprehensive painting and decorating solutions
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {services.map((service, index) => (
            <div
              key={index}
              className="bg-white p-8 rounded-lg shadow-lg hover:shadow-xl transition-shadow duration-300"
            >
              <div className="w-16 h-16 flex items-center justify-center bg-sky-100 rounded-lg mb-6">
                <i className={`${service.icon} text-3xl text-sky-600`}></i>
              </div>
              <h3 className="text-xl font-bold text-gray-800 mb-3">
                {service.title}
              </h3>
              <p className="text-sm text-gray-600 leading-relaxed">
                {service.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
